import { useEffect, useState } from "react";
import SidebarManager from "../../components/SidebarManager.js";
import Header from "../../components/Header.js";
import NumCard from "../../components/NumCard.js";
import CallToAction from "../../components/CallToAction.js";
import Table from "../../components/Table.js";
import data from "../../components/data.json";
import { useNavigate } from "react-router-dom";
import {
  getCompanyDetails,
  getDahboardStats,
} from "../../services/companyService.js";
import { getStatusColor } from "../../utils/statusUtils.js";
import StatsCards from "../../components/StatsCards.js";
import { useAuth } from "../../context/AuthContext.js";

const stats = [
  {
    amount: data.filter((row) => row.status === "approved").length,
    text: "Approved",
    colour: "#198754",
  },
  {
    amount: data.filter((row) => row.status === "pending").length,
    text: "Pending Approval",
    colour: "#ffb800",
  },
  {
    amount: data.filter((row) => row.status === "rejected").length,
    text: "Rejected",
    colour: "#c82333",
  },
];

const today = new Date().toLocaleDateString("en-GB", {
  weekday: "long",
  day: "2-digit",
  month: "short",
  year: "numeric",
});

function ManagerDashboard() {
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [stats, setStats] = useState([]);
  const { user } = useAuth();

  const navigate = useNavigate();

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      let response = await getCompanyDetails(user);
      if (response.length > 0) {
        response = response.map((x) => ({
          ...x,
          applicationStatusValue: x.applicationStatus.value,
        }));
        setCompanies(response);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Failed to load company data:", error);
    }
  };

  const fetchDashboard = async () => {
    try {
      const response = await getDahboardStats(user);
      setStats([
        {
          label: "Total Forms",
          value: response.totalForms,
          color: "text-indigo-500",
          border: "border-indigo-300",
        },
        {
          label: "Approved Forms",
          value: response.approvedForms,
          color: "text-green-600",
          border: "border-green-300",
        },
        {
          label: "Pending Forms",
          value: response.pendingForms,
          color: "text-yellow-500",
          border: "border-yellow-300",
        },
        {
          label: "Rejected Forms",
          value: response.rejectedForms,
          color: "text-red-500",
          border: "border-red-300",
        },
      ]);
    } catch (error) {
      console.error("Failed to fetch stats:", error);
    }
  };

  useEffect(() => {
    fetchDashboard();
    fetchCompanies();
  }, []);

  const columns = [
    { label: "Company Name", key: "name" },
    { label: "Registered Name", key: "registeredName", align: "start" },
    { label: "Website", key: "websiteUrl", align: "start" },
    {
      label: "Industries",
      key: "industries",
      align: "center",
      format: "arrayValue",
    },
    {
      label: "Onboarded on",
      key: "createdAt",
      align: "center",
      format: "date",
    },
    {
      label: "Action",
      key: "action",
      align: "center",
      render: (row) => (
        <span
          className={`text-white px-4 py-1 rounded-lg text-sm hover:opacity-90 ${getStatusColor(
            row.applicationStatus.id
          )}`}
          //onClick={() => redirectToForm(row)}
        >
          {row.applicationStatus.value}
        </span>
      ),
    },
  ];

  return (
    <div className="container py-8 px-[5rem] bg-[#fbfbfb]">
      <Header
        title="Manger Dashboard"
        date={today}
        buttons={false}
      />
      <div className="grid grid-cols-3 gap-6 justify-between mb-[2rem]">
        {/* {stats.map((stat, index) => (
          <NumCard amount={stat.amount} text={stat.text} colour={stat.colour} />
        ))} */}
      </div>
      <div className="mb-4">
        <StatsCards stats={stats} className="grid grid-cols-4 gap-4" />
      </div>
      <div
        className={
          " px-[5rem] py-[2rem] mb-[2rem] flex justify-between items-center bg-linear-to-r from-[#dfe3fa] to-white rounded-2xl outline-2 outline-gray-200"
        }
      >
        <div className="text-[#525357] text-left">
          <p className="text-4xl/[1.25] font-semibold">Hi, Manager</p>
          <p className="text-xl">Ready to start your day?</p>
        </div>
        <button
          className="bg-[#6f81f5] px-5 py-4 text-white rounded-xl text-lg cursor-pointer"
          onClick={() => navigate("/companies")}
        >
          Assign Form →
        </button>
      </div>

      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Assigned Forms</h2>
        <p className="text-sm mb-4 text-gray-500">Total: 2 Forms</p>
        <Table
          columns={columns}
          rows={companies}
          colour="#c5cdfb"
          loading={loading}
        />
      </div>
    </div>
  );
}
export default ManagerDashboard;
